export default "__VITE_ASSET__BN7C7tQ3__"